module.exports = __webpack_public_path__ + "static/individually-scrollable2-0560e7e660a0d9eb4345a82b95eaef15.gif";